export enum SlotType {
    CheckboxInlineSlot = 'CHECKBOX_INLINE_SLOT',
    CheckboxTileSlot = 'CHECKBOX_TILE_SLOT',
    RadioButtonInlineSlot = 'RADIO_BUTTON_INLINE_SLOT',
    RadioButtonTileSlot = 'RADIO_BUTTON_TILE_SLOT',
    NumericInputSlot = 'NUMERIC_INPUT_SLOT',
    NumericStepperSlot = 'NUMERIC_STEPPER_SLOT',
    NumericSliderSlot = 'NUMERIC_SLIDER_SLOT',
    TextInputSlot = 'TEXT_INPUT_SLOT',
    MultilineTextInputSlot = 'MULTILINE_TEXT_INPUT_SLOT',
    DateTimePickerSlot = 'DATE_TIME_PICKER_SLOT',
    DatePickerSlot = 'DATE_PICKER_SLOT',
    TimePickerSlot = 'TIME_PICKER_SLOT',
    OptionalNumericInputTileSlot = 'OPTIONAL_NUMERIC_INPUT_TILE_SLOT',
    OptionalTextInputTileSlot = 'OPTIONAL_TEXT_INPUT_TILE_SLOT',
    DropdownSlot = 'DROP_DOWN_SLOT',
    MultiselectDropdownSlot = 'DROP_DOWN_MULTISELECT_SLOT',
    SeparatorSlot = 'SEPARATOR_SLOT'
}
